if (!customElements.get('ls-complete-look')) {
  customElements.define('ls-complete-look', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      if (this.dataset.hasProducts === 'true') {
        this.ready = Promise.resolve();
        return;
      }
      this.loaded = true;
      this.ready = fetch(this.dataset.url, { signal: AbortSignal.timeout(8000) })
        .then(response => {
          if (!response.ok) throw new Error('Recommendations unavailable');
          return response.text();
        })
        .then(html => {
          if (!this.isConnected) return;
          const result = new DOMParser().parseFromString(html, 'text/html').querySelector('ls-complete-look');
          if (result?.dataset.hasProducts === 'true') {
            this.innerHTML = result.innerHTML;
            this.dataset.hasProducts = 'true';
          }
        })
        .catch(() => { /* Leave the section hidden if recommendations are unavailable. */ });
    }
  });
}
